import React from 'react'
import { withRouter } from 'react-router-dom'
import Authorization from '../../security/component/auth/AuthorizationContainer'
import {
    ROLE_ACCOUNTING,
    ROLE_EMPLOYEE_CUSTOMER_SERVICE,
    ROLE_EMPLOYEE_OFFICE,
    ROLE_EMPLOYEE_STORE,
    ROLE_PARTNER_PHYSICIAN,
    ROLE_PARTNER_SCAN_PHYSICIAN,
    ROLE_PROCESS_MANAGER,
    ROLE_REPORTING,
    ROLE_USER_ADMIN,
    ROLE_FOIL_METADATA_ADMIN,
    ROLE_WIDGET_ADMIN,
    ROLE_RETAIL_QA,
    ROLE_CLINIC_MANAGEMENT,
    ROLE_CUSTOMER_SERVICE_TEAM_LEAD,
} from '../../security/state/auth/const'

const NavigationItem = ({ locationPath, targetPath, name, history, icon, isNavigationCollapsed }) => {
    const className = locationPath === targetPath ? 'active' : ''

    return (
        <li className={className} onClick={() => {
            history.push(targetPath)
        }}>
            <i className={icon} title={name}/>
            {!isNavigationCollapsed && (<span>{name}</span>)}
        </li>
    )
}


const Navigation = ({ history, locationPath, isNavigationCollapsed }) => {
    const className = isNavigationCollapsed ? 'sidebar-small' : 'sidebar-large'
    return (
        <div className={className}>
            <ul className="main-navigation">

                <Authorization requiredRole={ROLE_REPORTING}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/process/task/all"
                        icon="fa fa-bar-chart-o"
                        name="Task Overview"/>
                </Authorization>

                <Authorization requiredRole={ROLE_REPORTING}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/analytics/sales-order"
                        icon="fa fa-bar-chart-o"
                        name="Invoice CSV"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/process/version-summary"
                        icon="fa fa-code-fork"
                        name="Process Version"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_EMPLOYEE_OFFICE, ROLE_EMPLOYEE_STORE]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/appointment/search"
                        icon="fa fa-calendar"
                        name="Appointment"/>
                </Authorization>

                <NavigationItem
                    isNavigationCollapsed={isNavigationCollapsed}
                    locationPath={locationPath}
                    history={history}
                    targetPath="/"
                    icon="fa fa-inbox"
                    name="Worklist"/>

                <NavigationItem
                    isNavigationCollapsed={isNavigationCollapsed}
                    locationPath={locationPath}
                    history={history}
                    targetPath="/worklist/attachment"
                    icon="fa fa-inbox"
                    name="Worklist Attachment"/>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/process/instance/barcode"
                        icon="fa fa-barcode"
                        name="Barcode Reader"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_EMPLOYEE_OFFICE, ROLE_EMPLOYEE_STORE, ROLE_PARTNER_SCAN_PHYSICIAN]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/customer/search"
                        icon="fa fa-child"
                        name="Customer"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_RETAIL_QA, ROLE_CLINIC_MANAGEMENT]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/store/search"
                        icon="fa fa-map-marker"
                        name="Clinics / Stores"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_PARTNER_PHYSICIAN]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/customer/search/partner"
                        icon="fa fa-child"
                        name="Customer"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_RETAIL_QA, ROLE_CLINIC_MANAGEMENT]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/partner/search"
                        icon="fa fa-group"
                        name="Partners"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/set"
                        icon="fa fa-shopping-cart"
                        name="Sets"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_EMPLOYEE_OFFICE, ROLE_EMPLOYEE_STORE]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/check-in"
                        icon="fa fa-shopping-cart"
                        name="Clinic Check-In"/>
                </Authorization>


                <Authorization requiredRole={[ROLE_EMPLOYEE_OFFICE, ROLE_EMPLOYEE_STORE]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/in-shop-scan"
                        icon="fa fa-shopping-cart"
                        name="Clinic 3D-Scan"/>
                </Authorization>


                <Authorization requiredRole={[ROLE_EMPLOYEE_OFFICE, ROLE_EMPLOYEE_STORE]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/shop-scan"
                        icon="fa fa-shopping-cart"
                        name="Shop Scan"/>
                </Authorization>


                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/treatment"
                        icon="fa fa-shopping-cart"
                        name="Treatments"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/refinement-set"
                        icon="fa fa-shopping-cart"
                        name="Refinement Set"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/refinement-booking"
                        icon="fa fa-shopping-cart"
                        name="Refinement Booking"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/refinement-shop"
                        icon="fa fa-shopping-cart"
                        name="Refinement Shop Scan"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/refinement-production"
                        icon="fa fa-shopping-cart"
                        name="Refinement Treatment"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_CUSTOMER_SERVICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/end-of-treatment"
                        icon="fa fa-shopping-cart"
                        name="End Treatment"/>
                </Authorization>


                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/retainer"
                        icon="fa fa-shopping-cart"
                        name="Retainer"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/retainer-refinement"
                        icon="fa fa-shopping-cart"
                        name="Retainer Refinement"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_CUSTOMER_SERVICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/sales-order/search/escalation"
                        icon="fa fa-bolt"
                        name="Escalation"/>
                </Authorization>


                <Authorization requiredRole={ROLE_ACCOUNTING}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/payment/associate"
                        icon="fa fa-money"
                        name="Payments"/>
                </Authorization>

                <Authorization requiredRole={ROLE_ACCOUNTING}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/payment/upload"
                        icon="fa fa-money"
                        name="Upload Payment"/>
                </Authorization>

                <Authorization requiredRole={ROLE_USER_ADMIN}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/user/manage"
                        icon="fa fa-user"
                        name="Manage User"/>
                </Authorization>

                <Authorization requiredRole={ROLE_WIDGET_ADMIN}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/role/widgets"
                        icon="fa fa-gears"
                        name="Manage Widgets"/>
                </Authorization>

                <Authorization requiredRole={ROLE_EMPLOYEE_OFFICE}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/settings/employee"
                        icon="fa fa-cog"
                        name="My Settings"/>
                </Authorization>

                <Authorization requiredRole={ROLE_PROCESS_MANAGER}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/process/task-definition/all"
                        icon="fa fa-gears"
                        name="Task Definition"/>
                </Authorization>

                <Authorization requiredRole={ROLE_FOIL_METADATA_ADMIN}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/foil/overview"
                        icon="fa fa-gears"
                        name="Foil Metadata"/>
                </Authorization>

                <Authorization requiredRole={[ROLE_CUSTOMER_SERVICE_TEAM_LEAD, ROLE_EMPLOYEE_CUSTOMER_SERVICE]}>
                    <NavigationItem
                        isNavigationCollapsed={isNavigationCollapsed}
                        locationPath={locationPath}
                        history={history}
                        targetPath="/voucher/search"
                        icon="fa fa-search"
                        name="Vouchers"/>
                </Authorization>

            </ul>
        </div>
    )
}


export default withRouter(Navigation)





// WEBPACK FOOTER //
// ./src/modules/layout/component/Navigation.js